import QuoteTotalCard from './QuoteTotalCard'

export default QuoteTotalCard
